<template>
	<div>
		<a-modal v-show='!ishand' id='handitemqi' width='36rem' v-model="visible" on-ok="handleOk1"
			v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="width: 34rem;">
					申請假期
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div  style="width: 34rem;" class='body_lis'>
				<!--  v-if='false' -->
				<div style="margin: 0 auto;padding-top: 1.5rem;width: 90%;">
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' layout="inline" :rules='rules'
						hideRequiredMark>
						<!-- <a-row>
							<a-col :span='14'>
								<a-col :span='7' class='titName' v-html='"員工姓名&nbsp;&nbsp;:"'></a-col>
								<a-col :span='17' class='comname'>{{formview.realname}}
									<img v-if='formview.sex == 1' :src="require('@/image/lea/man.png')" alt="">
									<img v-if='formview.sex == 2' :src="require('@/image/lea/woman.png')" alt="">
								</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='9' class='titName' v-html='"申請日期&nbsp;&nbsp;:"'></a-col>
								<a-col :span='15' class='comname'>{{formview.createtime}}</a-col>
							</a-col>
							<a-col :span='14'>
								<a-col :span='7' class='titName '
									v-html='"部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;門&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='17' class='comname'>{{formview.department}}</a-col>
							</a-col>
							<a-col :span='10'>
								<a-col :span='9' class='titName '
									v-html='"職&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位&nbsp;&nbsp;:"'>
								</a-col>
								<a-col :span='15' class='comname'>{{formview.job}}</a-col>
							</a-col>
						</a-row> -->
						<rl @child='handff' :stas='1' :listdate='backform' :asktype='form.asktype'></rl>
						<br>
						<a-form-model-item label="">
							<a-radio-group v-model="form.asktype" @change='asktypefn'>
								<div style="position: relative;">
									<a-radio :value="item.value*1" v-for='(item,ind) in yeararr' :key='ind+"vbs"'
										:style='{margin:ind +1 == yeararr.length?"0  0 0 7rem":""}'
										:class='item.cla==1?"myauto":item.cla==2?"mayright":""'>
										{{item.text}}
									</a-radio>
									<a-input v-model="form.otherasktype" class='warp_width'
										:disabled='form.asktype  !== 0' placeholder='請輸入其他假期'
										style='width: 12.4rem;position: absolute;right: -0.8rem;bottom: -0rem;' />
								</div>
							</a-radio-group>
						</a-form-model-item>
						<div>
							<a-form-model-item prop='remark'>
								<div slot="label" v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註&nbsp;&nbsp;"'
									style="display: inline-block;color: #000000;"></div>
								<a-input v-model="form.remark" class='warp_width' placeholder='請輸入備註'
									style='width: 23.4rem;position: relative;left: .8rem;' />
							</a-form-model-item>
						</div>
						<a-form-model-item>
							<div slot="label" v-html='"假期時間&nbsp;&nbsp;"' style="display: inline-block;color: #000000;">
							</div>
							<div style="position: relative;left: .7rem;display: inline-block;">
								<a-select v-model="form.begintime" class='warp_width' style='width: 9.25rem;'>
									<a-select-option v-for="(item,inds) in Arr1" :key="inds+'a'" :value="item.value">
										{{item.text }}
									</a-select-option>
								</a-select>
								<div style="display: inline-block;margin: 0 1.3rem;left: .9rem;position: relative;">-
								</div>
								<a-select v-model="form.endtime" class='warp_width'
									style='width: 9.25rem;left: 1.8rem;'>
									<a-select-option v-for="(item,indv) in admintypeArrs" :key="indv+'as'"
										:value="item.value">{{item.text}}</a-select-option>
								</a-select>
							</div>
						</a-form-model-item>
						<div>
							<div style="width: 58%;display: inline-block;">
								<a-form-model-item>
									<div slot="label" v-html='"假期天數&nbsp;&nbsp;"'
										style="display: inline-block;color: #000000;"></div>
									<div style="display: inline-block;margin-left: .7rem;"
										:style='{color:form.fants?"red":""}'>{{form.day_hour}}</div>
								</a-form-model-item>
							</div>
							<!-- <div style="display: inline-block;" v-if='form.asktype == 1'>
								<a-form-model-item>
									<div slot="label" v-html='"剩餘假期&nbsp;&nbsp;"'
										style="display: inline-block;color: #000000;"></div>
									<div style="display: inline-block;margin-left: .7rem;">
										{{form.yearholiday_days*1+' 天'}}
									</div>
								</a-form-model-item>
							</div> -->
						</div>
					</a-form-model>
					<div style="text-align: center;padding-bottom: 1.2rem;">
						<button class='btn1 btnx' @click='resetForm("1")'>
							<!-- 下單 -->
							儲存
						</button>
						<button class='btn1 btn2' @click='resetForm("2")'>提交</button>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import rl from './rlmate.vue'
	import App from '@/assets/app.js';

	export default {
		props: ['pared'],
		components: {
			rl
		},
		data() {
			return {
				visible: true,
				ishand: false,
				rules: {},
				formview: {
					createtime: "23/06/2021",
					department: "行政",
					position: "前台客服",
					realname: "song",
					sex: 0,
				},
				backform: {
					begindates: '',
					enddates: ''
				},
				form: {
					"type": 1, //類型 1 假期申請 2 外出 3加班
					"asktype": 1, // 1年假 2病假 3婚假 4產假 5陪產假 6喪假 7無薪休假 0其他
					"otherasktype": "", //  其他請假形式
					"remark": "",
					"begindate": "",
					enddate: '',
					"begintime": "9:00",
					// "enddate": "2021-6-7",
					"endtime": "18:00",
					day_hour: '',
					yearholiday_days: ''
				},
				yeararr: [{
					text: '年假',
					value: '1',
				}, {
					text: '病假',
					value: '2',
					cla: '1'
				}, {
					text: '婚假',
					value: '3',
					cla: '2'
				}, {
					text: '產假',
					value: '4',
				}, {
					text: '陪產假',
					value: '5',
					cla: '1'
				}, {
					text: '喪假',
					value: '6',
					cla: '2'
				}, {
					text: '無薪休假',
					value: '7',
				}, {
					text: '其他',
					value: '0',
					cla: '1'
				}, ],
				Arr1: [{
					text: '9:00',
					value: '9:00',

				}, {
					text: '14:00',
					value: '14:00',
				}],
				admintypeArrs: [{
					// 	text: '9:00',
					// 	value: '9:00',
					// }, {
					text: '13:00',
					value: '13:00',
					// }, {
					// 	text: '14:00',
					// 	value: '14:00',
				}, {
					text: '18:00',
					value: '18:00',
				}],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
				],
			}
		},
		watch: {
			form: {
				deep: true,
				handler(ev) {
					this.datafn()
				}
			}
		},
		mounted() {
			this.handimg()
		},
		methods: {

			asktypefn() {
				if (this.form.asktype !== 0) {
					this.form.otherasktype = ''
				}
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || '',
						token: this.$store.state.token
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						if (this.pared.applyid) {
							this.form = res.data
							this.form.num = Math.ceil(this.form.day_hour.split(' ')[0]);
							this.backform.begindates = this.form.begindate
							this.backform.enddates = this.form.enddate
						}
						// this.form.yearholiday_days = res.data.yearholiday_days
						// console.log(res.data,this.form,this.form.yearholiday_days)
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			datafn() {
				if (this.form.num) {
					if ((this.form.begintime == '9:00' || this.form.begintime == '09:00') && this.form.endtime ==
						'18:00') {
						this.form.day_hour = this.form.num + ' 天'
					} else {
						if ((this.form.begintime == '14:00') && (this.form.endtime == '13:00' || this.form.endtime ==
								'14:00')) {
							this.form.day_hour = this.form.num - 1 + ' 天'
						} else {
							this.form.day_hour = this.form.num - .5 + ' 天'
						}
					}
					// if (this.form.day_hour) {
					// 	if (this.form.day_hour.split(' ')[0] * 1 > this.form.yearholiday_days * 1) {
					// 		// App.oTool.warningT('剩餘假期天數不足');
					// 		this.form.fants = true
					// 	} else {
					// 		this.form.fants = false
					// 	}
					// }
				}
			},
			handff(val, num) {
				// console.log(val, num)
				this.$set(this.form, 'num', num ? num : 0)
				this.form.begindate = ''
				this.form.enddate = ''
				if (val) {
					if (val.length > 1) {
						this.form.begindate = val[0]
						this.form.enddate = val[1]
					} else if (val.length == 1) {
						this.form.begindate = val[0]
						this.form.enddate = val[0]
					}
				}
			},
			handcal(ev) {
				// console.log(ev)
			},
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' +
					(time
						.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			backfn(gucode) {
				let str = ''
				this.Arr1.map(ev => {
					if (ev.value == this.form.exchange_code) {
						str = ev[gucode]
					}
				})
				return str
			},
			resetForm(val) {
				if (this.form.asktype == 0) {
					if (!this.form.otherasktype) {
						App.oTool.warningT('請輸入其他假期');
						return
					}
				}
				if (!this.form.begindate) {
					App.oTool.warningT('請選擇休假時間');
					return
				}
				if (!this.form.enddate) {
					App.oTool.warningT('請選擇休假時間');
					return
				}
				// if (this.form.day_hour.split(' ')[0] * 1 > this.form.yearholiday_days * 1) {
				// 	App.oTool.warningT('剩餘假期天數不足');
				// 	return
				// }
				// console.log(this.form.enddate,this.form,this.form.day_hour.split(' ')[0]*1,this.form.yearholiday_days.split(' ')[0]*1)
				// return 
				this.form.issave = ''
				this.form.issave = val
				this.form.type = 1
				this.form.token = this.$store.state.token;
				// this.$refs[formName].resetFields();

				this.$ajax({
					method: 'post',
					url: this.$api.newApply,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#handitemqi {
		.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: red !important;
		}

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 7rem;
		}

		.mayright {
			margin-left: 1rem;
			left: 2rem;
			position: relative;
		}

		.titName {
			font-size: 0.8rem !important;
			color: #000;
			height: 2rem;
		}

		.comname {
			font-size: 0.8rem !important;
		}

		.ant-modal {
			top: 9vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: 0.8rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .6rem;
		}

		.ant-form-item label {
			font-size: 0.8rem !important;
			width: 4rem;
			margin-bottom: .3rem;
		}

		.ant-input {
			font-size: 0.8rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: 0.8rem !important;
		}

		.ant-form-item-children {
			font-size: 0.8rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
